/*
choixPAGE==0 : 
choixPAGE==1 : modifier-supprimer 1 seul étudiant
choixPAGE==2 : voir les copies d'un étudiant (si nb page >=2... sinon, il y a le menu 'copie')
choixPAGE==3 : liste des étudiants



*/

app.controller('etuCtrl', function ($rootScope, $scope, services, $location, ngTableParams, $filter, FileUploader, ServiceQcm, toastr, $q) {

    var _DEBUG = 0;
    $scope.url_ = $rootScope.url_;

    /*************************************************************/
    var majTab = function () {
        services.listeGroupe(1).then(function (data) {
            $scope.listeGroupe = data.data;
            if ($scope.listeGroupe.length == 0) toastr.info('___pas encore de groupe___');
            $scope.a = $rootScope.qcmSelectionne;

            services.listeGroupeQCM($rootScope.qcmSelectionne.id).then(function (data) {
                $scope.listeGroupeQCM = data.data;
            })
                .catch(function (response) {
                    $location.path('/0lst');//document.location.href
                })
                .finally(function (data) {
                    var i = 0, j = 0;
                    for (i = 0; i < $scope.listeGroupeQCM.length; i++) {
                        for (k = 0; k < $scope.listeGroupe.length; k++) {
                            if ($scope.listeGroupe[k].lib == $scope.listeGroupeQCM[i].lib) {
                                $scope.listeGroupe.splice(k, 1);
                            }
                        }
                    }
                    if ($scope.listeGroupe.length > 0) $scope.sel1 = $scope.listeGroupe[0];
                    $scope.tableDesGroupes.reload();
                });

        })
            .catch(function (response) {
                $location.path('/0lst');//document.location.href
            })
            .finally(function (data) {
            });
    }
    /*************************************************************/

    $scope.choixPAGE = 3;
    $scope.data = [];

    $scope.init = function () {

        $rootScope.menuSelectionne = 3;
        $scope.afficheFichier = 0;

        if (typeof ($rootScope.qcmSelectionne) == "undefined") {
            $scope.choixQCM = -1;
            $rootScope.menuSelectionne = 1;
            //document.location.href = "/#/1qcm"
            $location.path('/0lst');//document.location.href

        } else {
            /*            services.listeGroupe(1).then(function(data){
                            $scope.listeGroupe = data.data;
                            toastr.info('___pas encore de groupe___');
                            $scope.a=$rootScope.qcmSelectionne;
                        
                            services.listeGroupeQCM($rootScope.qcmSelectionne.id).then(function(data){
                                $scope.listeGroupeQCM = data.data;
                                toastr.info('___pas encore de groupe___');*/
            //------------------------------------------------------------
            $scope.listeGroupeQCM = [];
            var nb_max2 = Math.max($scope.listeGroupeQCM.length, 100);

            $scope.tableDesGroupes = new ngTableParams({
                page: 1,            // show first page
                count: 10,           // count per page
                sorting: { id: 'Numero' }
            }, {
                total: $scope.listeGroupeQCM.length,
                counts: [10, 25, nb_max2],
                getData: function ($defer2, params2) {

                    //$scope.var  = params//pour affichage uniquement (à supprimer apres)  !!
                    $scope.data2 = params2.filter() ? $filter('filter')($scope.listeGroupeQCM, params2.filter()) : $scope.listeGroupeQCM;
                    $scope.data2 = params2.sorting() ? $filter('orderBy')($scope.data2, params2.orderBy()) : $scope.listeGroupeQCM;
                    $scope.data2 = $scope.data2.slice((params2.page() - 1) * params2.count(), params2.page() * params2.count());
                    $defer2.resolve($scope.data2);
                }
            });
            majTab();




            $scope.choixQCM = $rootScope.qcmSelectionne.id;
            $scope.listeEtudiant = $rootScope.qcmSelectionne.listeEtudiant;
            //$scope.data2 = $rootScope.qcmSelectionne.listeEtudiant;
            $scope.nbEtudiant = $rootScope.qcmSelectionne.nbEtudiant;
            $scope.a = $rootScope.qcmSelectionne
            //tab()
            $scope.page = $rootScope.qcmSelectionne.page;
            if ($rootScope.qcmSelectionne.listeEtudiant.length == 0) {
                $scope.afficheFichier = 1;
                toastr.info('___Envoyer la liste de vos étudiants___');
            }

        }
    };
    /*************************************************************/
    if (typeof ($scope.data) === "undefined") {   // eviter erreur du début
        $scope.data = [];
    }
    //}else{
    /*
        if (localStorage.getItem("Aff_nbEtudiant") === undefined) {
            nombre=10;
        }else{
            nombre = localStorage.getItem("Aff_nbEtudiant");
        }
        if (nombre<10)nombre=10;
    */
    var nb_max = Math.max($rootScope.qcmSelectionne.listeEtudiant.length, 100);

    $scope.listeEtudiant = $rootScope.qcmSelectionne.listeEtudiant;
    $scope.tableDesEtudiants = new ngTableParams({
        page: 1,            // show first page
        count: 10,           // count per page
        sorting: { id: 'Numero' }
    }, {
        total: $scope.listeEtudiant.length,
        counts: [10, 25, nb_max],
        getData: function ($defer, params) {

            //$scope.var  = params//pour affichage uniquement (à supprimer apres)  !!
            $scope.data = params.filter() ? $filter('filter')($scope.listeEtudiant, params.filter()) : $scope.listeEtudiant;
            $scope.data = params.sorting() ? $filter('orderBy')($scope.data, params.orderBy()) : $scope.listeEtudiant;
            $scope.data = $scope.data.slice((params.page() - 1) * params.count(), params.page() * params.count());
            $defer.resolve($scope.data);
        }


    });
    // }
    var nbEtudiant_avant = $rootScope.qcmSelectionne.nbEtudiant;
    var erreur = 0;
    var uploader = $scope.uploader = new FileUploader({
        url: '/envoiEtudiant/',
        formData: [{ 'token': $rootScope.user.token, 'id': $rootScope.qcmSelectionne.id, 'param': "scan" }]
        //formData: [$rootScope.qcmSelectionne]
    });

    // FILTERS

    uploader.filters.push({
        name: 'customFilter',
        fn: function (item /*{File|FileLikeObject}*/, options) {
            return this.queue.length < 10;
        }
    });

    uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
        if (_DEBUG) console.info('onWhenAddingFileFailed', item, filter, options);
    };
    uploader.onAfterAddingFile = function (fileItem) {
        if (_DEBUG) console.info('onAfterAddingFile', fileItem);
    };
    uploader.onAfterAddingAll = function (addedFileItems) {
        if (_DEBUG) console.info('onAfterAddingAll', addedFileItems);
    };
    uploader.onBeforeUploadItem = function (item) {  // le nom 'token' est celui définit dans le programme 'satellizer.js' dans node_modules
        if (item.file.size >= 1024 * 100) {//limite 100ko
            toastr.error("___fichier trop gros___");
            //this.queue.length=0;
            erreur = 1;
            return;
        }

        item.headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
        if (_DEBUG) console.info('onBeforeUploadItem', item);
        nbEtudiant_avant = $rootScope.qcmSelectionne.nbEtudiant;

    };
    uploader.onProgressItem = function (fileItem, progress) {
        if (_DEBUG) console.info('onProgressItem', fileItem, progress);
    };
    uploader.onProgressAll = function (progress) {
        if (_DEBUG) console.info('onProgressAll', progress);
    };
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
        if (_DEBUG) console.info('onSuccessItem', fileItem, response, status, headers);
    };
    uploader.onErrorItem = function (fileItem, response, status, headers) {
        if (_DEBUG) console.info('onErrorItem', fileItem, response, status, headers);
    };
    uploader.onCancelItem = function (fileItem, response, status, headers) {
        if (_DEBUG) console.info('onCancelItem', fileItem, response, status, headers);
    };
    uploader.onCompleteItem = function (fileItem, response, status, headers) {
        if (erreur == 1) return;
        if (response.stdout == "pb: pas un fichier etudiant") {
            toastr.error("___Ce n'est pas un fichier de solution compatible___");
        }
    };
    uploader.onComplete = function (response, status, headers) {
        if (_DEBUG) console.info('onComplete', response, status, headers);
    };

    uploader.onCompleteAll = function () {
        if (erreur == 1) { erreur = 0; return; }

        var deferred = $q.defer();

        try {

            console.log('onCompleteAll');
            nbEtudiant_avant = $rootScope.qcmSelectionne.nbEtudiant
            $scope.loader = 1;

            new ServiceQcm.chargement($rootScope.qcmSelectionne).then(function (data) {

                $scope.qcmSelectionne = $rootScope.qcmSelectionne
                //$scope.data = $rootScope.qcmSelectionne.listeCopie;
                ////$scope.data2 = $scope.data;

                //resCopie = $rootScope.qcmSelectionne.listeCopie
                //nbcopies = $rootScope.qcmSelectionne.listeCopie.length

                $scope.nbEtudiant = $rootScope.qcmSelectionne.listeEtudiant.length;
                $scope.listeEtudiant = $scope.qcmSelectionne.listeEtudiant;

                v = $rootScope.qcmSelectionne.nbEtudiant - nbEtudiant_avant
                if (v <= 0)
                    toastr.error("___L'importation des étudiants a échoué.___")
                else {
                    toastr.success(v + "___étudiants importés.___");
                    document.getElementById("myModal").click();
                }
                uploader.progress = 0;
                $scope.tableDesEtudiants.reload();
                $scope.loader = 0;
            })
        } catch (e) {
            deferred.reject(e);
        }//try-catch

        $scope.afficheFichier = 0;

        return deferred.promise


        /*
        
                // récupérer la solution
        
                services.listeEtudiant($rootScope.qcmSelectionne.id).then(function(data){
                    $rootScope.qcmSelectionne.listeEtudiant = data.data;
                    $scope.data = data.data;
                    $scope.nbEtudiant = $rootScope.qcmSelectionne.listeEtudiant.length;
                    //$scope.data2 = $scope.data
        
                    // recharger la liste des étudiants
                    new ServiceQcm.initListeEtudiant($rootScope.qcmSelectionne)
                    new ServiceQcm.calculNotes($rootScope.qcmSelectionne);
        
        
                    $scope.data = $rootScope.qcmSelectionne.listeEtudiant
                    $scope.nbEtudiant = $rootScope.qcmSelectionne.listeEtudiant.length;
                    //$scope.data2 = $scope.data
                    $scope.a=$rootScope.qcmSelectionne.listeEtudiant
                    $scope.b=$rootScope.qcmSelectionne.listeCopie
        
                    $scope.tableDesEtudiants.data = $rootScope.qcmSelectionne.listeEtudiant
                    $scope.tableDesEtudiants.reload();
        
        
                    var v=data.data.length - nbEtudiant_avant
        
                    if (nbEtudiant_avant == $rootScope.qcmSelectionne.nbEtudiant) 
                        toastr.error("___L'importation des étudiants a échoué.___")
                    else 
                        toastr.success( v + "___étudiants importés.___")
        
        
                });
                $scope.afficheFichier=0;
        
        */

    };

    /*************************************************************/
    $scope.envoyerFichier = function () {
        if ($scope.afficheFichier == 0)
            $scope.afficheFichier = 1;
        else
            $scope.afficheFichier = 0;
    };

    /*************************************************************/
    $scope.toggleModal = function (val) {// aller dans le menu "nouvel étudiant"
        $scope.afficheFichier = 0;

        //alert("ok, val="+typeof(val) );
        if (typeof (val) == "number") {//nouvel etudiant
            //astuce : id = id du qcm !!!
            $scope.etudiantModifie = { "id": $rootScope.qcmSelectionne.id, "": "", "prenom": "", "numero": 0 };
            if (val == 0) $scope.choixPAGE = 0;
            //if (val==1) $scope.choixPAGE=4;

        } else {//modification ou suppression d'un etudiant
            $scope.choixPAGE = 1;
            $scope.etudiantModifie = val;
        }
    }

    /*************************************************************/
    $scope.submit = function () {

        if ($scope.choixPAGE == 0) {//nouvel étudiant

            if (typeof ($scope.etudiantModifie.numero) == "undefined") {
                toastr.error("___Entrer un numéro d'étudiant valide___");
                return
            } else if ($scope.etudiantModifie.numero == "") {
                toastr.error("___Entrer un numéro d'étudiant valide___");
                return
            }

            services.ajouterETUDIANT($scope.etudiantModifie, "scan")
                .then(function (data) {
                    toastr.info('___étudiant créé___');
                    $rootScope.qcmSelectionne.listeEtudiant.push({
                        "idetudiant": $scope.etudiantModifie.idetudiant, "nom": $scope.etudiantModifie.nom,
                        "prenom": $scope.etudiantModifie.prenom, "numero": $scope.etudiantModifie.numero,
                        "idqcm": $rootScope.qcmSelectionne.id, "idetudiantDuplicate": null,
                        "note20": null, "nbcopie": 0, "reponse": "((((((((((((((((((((((((((((((((((((((((((((", "moyenne": -100,
                        "sommenote": -100, "tabIndiceCopie": [-1], "lib": ""
                    })

                    $scope.data = $rootScope.qcmSelectionne.listeEtudiant
                    $scope.tableDesEtudiants.reload();
                    $scope.etudiantModifie = [];
                })
            $scope.choixPAGE = 3;
        }

        if ($scope.choixPAGE == 1) {//modifié étudiant

            services.modifierETUDIANT($scope.etudiantModifie, "scan")
                .then(function (data) {
                    for (i = 0; i < $rootScope.qcmSelectionne.listeEtudiant.length; i++) {

                        if ($rootScope.qcmSelectionne.listeEtudiant[i].idetudiant == $scope.etudiantModifie.idetudiant) {
                            if (_DEBUG) console.info("(+)")

                            $rootScope.qcmSelectionne.listeEtudiant[i].nom = $scope.etudiantModifie.nom
                            $rootScope.qcmSelectionne.listeEtudiant[i].prenom = $scope.etudiantModifie.prenom
                            $rootScope.qcmSelectionne.listeEtudiant[i].numero = $scope.etudiantModifie.numero
                            $scope.data = $rootScope.qcmSelectionne.listeEtudiant
                            $scope.tableDesEtudiants.reload();
                            i = 50000
                        }
                    }
                    $scope.etudiantModifie = [];

                })

            toastr.info('___étudiant modifié___');
            $scope.choixPAGE = 3;
        }
    }


    /*************************************************************/
    $scope.delete = function () {//supprimer étudiant
        //astuce, idqcm = numero
        $scope.etudiantModifie.numero = $rootScope.qcmSelectionne.id
        var id = $scope.etudiantModifie.idetudiant
        services.effacerETUDIANT($scope.etudiantModifie, "scan")
            .then(function (data) {
                // tenir à jour qcmSelectionne
                for (var i = 0; i < $rootScope.qcmSelectionne.listeEtudiant.length; i++) {
                    if ($rootScope.qcmSelectionne.listeEtudiant[i].idetudiant == id) {
                        $rootScope.qcmSelectionne.listeEtudiant.splice(i, 1);
                        i = 500000;
                    }
                }

                $scope.data = $rootScope.qcmSelectionne.listeEtudiant;
                $scope.tableDesEtudiants.reload();

                //$scope.data2 = $rootScope.qcmSelectionne.listeEtudiant;        
            })

            .catch(function (response) {
            })
            .finally(function (data) {
                $scope.tableDesEtudiants.reload();

            })

        if ($scope.choixPAGE == 1) {
            //alert("supprimer cet étudiant :"+$scope.etudiantModifie.idetudiant);
        }
        $scope.choixPAGE = 3;
        $scope.etudiantModifie = [];

        /*        services.listeEtudiant($rootScope.qcmSelectionne.id).then(function(data){
                    $rootScope.qcmSelectionne.listeEtudiant = data.data;
                    $scope.data = data.data;
                    $scope.nbEtudiant = $rootScope.qcmSelectionne.listeEtudiant.length;
                    $rootScope.qcmSelectionne.nbEtudiant = $rootScope.qcmSelectionne.listeEtudiant.length
                    //$scope.data2 = $scope.data
                });*/
    }
    /*************************************************************/
    $scope.deleteAll = function () {//supprimer tous les étudiants
        //astuce, idqcm = numero
        services.effaceAllETUDIANTS($rootScope.qcmSelectionne.id, 'scan')
            .then(function (data) {
                $rootScope.qcmSelectionne.listeEtudiant = []
                $rootScope.qcmSelectionne.nbEtudiant = 0

                $scope.data = [];
                //$scope.data2 = []

                for (i = 0; i < $rootScope.qcmSelectionne.listeCopie.length; i++) {
                    $rootScope.qcmSelectionne.listeCopie[i].idetudiant = 0
                    $rootScope.qcmSelectionne.listeCopie[i].nom = 0
                    $rootScope.qcmSelectionne.listeCopie[i].prenom = 0
                }
                $rootScope.qcmSelectionne.nbTotal = 0
                $rootScope.qcmSelectionne.sommenote = 0
                $rootScope.qcmSelectionne.moyenne = 0
                //$rootScope.ajouterQCM = data.data;
            })
            .catch(function (response) {
            })
            .finally(function (data) {
                majTab();
            })

        if ($scope.choixPAGE == 1) {
            //alert("supprimer cet étudiant :"+$scope.etudiantModifie.idetudiant);
        }
        $scope.choixPAGE = 3;
        $scope.etudiantModifie = null;
        //majListe()

        $scope.data = [];
        $scope.tableDesEtudiants.reload();

    }
    /*************************************************************/
    /*
        majListe = function(){
            services.listeEtudiant($rootScope.qcmSelectionne.id).then(function(data){
                $rootScope.qcmSelectionne.listeEtudiant = data.data;
                $scope.data = data.data;
                $scope.nbEtudiant = $rootScope.qcmSelectionne.listeEtudiant.length;
                $rootScope.qcmSelectionne.nbEtudiant = $rootScope.qcmSelectionne.listeEtudiant.length
                //$scope.data2 = $scope.data
            });
        }
    */
    /*************************************************************/
    var suprimerDoublonsEtudiant = function () {
        // supprimer les doublons dans la liste des étudiants
        // à faire : identifier les étudiants différents qui ont le même numéro !!
        nb = $rootScope.qcmSelectionne.listeEtudiant.length
        if (nb <= 1) return
        tab = new Array()
        nbEfface = 0
        for (i = 0; i < nb - 1; i++) {
            for (j = i + 1; j < nb; j++) {
                if (($rootScope.qcmSelectionne.listeEtudiant[i].nom == $rootScope.qcmSelectionne.listeEtudiant[j].nom) && ($rootScope.qcmSelectionne.listeEtudiant[i].prenom == $rootScope.qcmSelectionne.listeEtudiant[j].prenom) && ($rootScope.qcmSelectionne.listeEtudiant[i].numero == $rootScope.qcmSelectionne.listeEtudiant[j].numero)) {
                    tab.push(j)
                    nbEfface++
                    j = nb// on quitte
                }
            }
        }
        for (i = nbEfface - 1; i >= 0; i++) {
            $rootScope.listeEtudiant.splice($rootScope.listeEtudiant.indexOf($rootScope.listeEtudiant[tab[i]]), 1);
        }
        // associer les étudiants aux copies (qui n'en n'ont pas encore... ou à toutes les copies ???)


        //majListe()
    }

    /*************************************************************/
    $scope.cancel2 = function () {
        $scope.choixPAGE = 3;
    }
    /******************************************************************************************************/
    $scope.cancel = function () { //revenir à la liste des qcm
        //$rootScope.afficheListeQcm=1;
        $location.path('/0lst');
    }
    /******************************************************************************************************/
    $scope.afficher_copies = function (user) {
        $scope.choixPAGE = 3;
        toastr.warning("pas encore implémenté...")



    }
    /******************************************************************************************************/
    $scope.ajouterGroupeQcm = function (sel) {
        if (sel.lib == "") return;
        services.ajouterGroupeQcm(sel.idGroupe, $rootScope.qcmSelectionne.id).then(function (data) {
            toastr.info(data.data.r + ' ___étudiants insérés___');
            majTab();
        })
            .catch(function (response) {
                $location.path('/0lst');//document.location.href
            })
            .finally(function (data) {
                new ServiceQcm.chargement($rootScope.qcmSelectionne).then(function (data) {
                    $scope.qcmSelectionne = $rootScope.qcmSelectionne
                    $scope.nbEtudiant = $rootScope.qcmSelectionne.listeEtudiant.length;
                    $scope.listeEtudiant = $scope.qcmSelectionne.listeEtudiant;
                    $scope.tableDesEtudiants.reload();

                });
            });


    }
    /******************************************************************************************************/
    $scope.supprimerGroupeQcm = function (sel) {
        if (sel.lib == "") return;
        services.supprimerGroupeQcm(sel.idGroupe, $rootScope.qcmSelectionne.id).then(function (data) {
            toastr.info(data.data.r + ' ___étudiants enlevés___');
            majTab();
        })
            .catch(function (response) {
                $location.path('/0lst');//document.location.href
            })
            .finally(function (data) {
                new ServiceQcm.chargement($rootScope.qcmSelectionne).then(function (data) {
                    $scope.qcmSelectionne = $rootScope.qcmSelectionne
                    $scope.nbEtudiant = $rootScope.qcmSelectionne.listeEtudiant.length;
                    $scope.listeEtudiant = $scope.qcmSelectionne.listeEtudiant;
                    $scope.tableDesEtudiants.reload();

                });
            });
    }
    /*************************************************************/
    $scope.lesgroupes = function () {
        document.getElementById("myModalGroupe").click();
        $location.path('/groupe');
    }
    /******************************************/

});
